import React, { useState } from 'react'
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import styled from 'styled-components'

import { APIURL } from '/constants'
import services from '/components/services'

export const Sharing = ({
  siteData,
  isLoggedIn,
  product,
  productUserData,
  registerCallback
}) => {
  const [favorite, setFavorite] = useState(productUserData?.favorited || false)
  if (!siteData.get('allow_dashboard')) {
    return null
  }
  /*
  if (!isLoggedIn) {
    return null
  }
  */
  const toggleFavorite = async () => {
    if (!isLoggedIn) {
      registerCallback()
    }
    try {
      let data = null
      if (!favorite) {
        data = await services.post_v2(APIURL.API_PRODUCT_FAVORITE(product.slug))
      } else {
        data = await services.delete_v2(
          APIURL.API_PRODUCT_FAVORITE(product.slug)
        )
      }
      if (data && data.statusCode === 200) {
        setFavorite(data.response.favorited)
      }
    } catch (e) {
      console.error(e)
    }
  }
  return (
    <ActionRow>
      <FavoriteButton onClick={toggleFavorite}>
        {favorite ? <AiFillHeart /> : <AiOutlineHeart />} Favorite
      </FavoriteButton>
    </ActionRow>
  )
}

const ActionRow = styled.div`
  padding: 10px 0;
`

const FavoriteButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    color: ${(props) => props.theme.colors.danger};
    font-size: 1.5rem;
  }
`
